import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";

export default function FinalCTA({
    eyebrow = "Let's build",
    title = "Build your AI roadmap with Perceptiqx",
    description = "Whether you're scoping an AI product, hiring specialised talent or modernising an enterprise platform — our teams ship measurable outcomes.",
    primary = { to: "/contact", label: "Talk to our team" },
    secondary = { to: "/ai-solutions", label: "Explore AI services" },
}) {
    return (
        <section
            data-testid="final-cta-section"
            className="relative py-20 md:py-28 overflow-hidden"
        >
            <div className="pqx-container">
                <div className="relative rounded-[28px] overflow-hidden pqx-dark-panel px-7 md:px-16 py-14 md:py-20">
                    <div className="absolute inset-0 pqx-grid-bg-dark opacity-40" />
                    <div
                        className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full pointer-events-none blur-3xl"
                        style={{ background: "radial-gradient(circle, rgba(255,64,64,0.32), transparent 60%)" }}
                    />
                    <div
                        className="absolute -bottom-40 -left-24 w-[420px] h-[420px] rounded-full pointer-events-none blur-3xl opacity-50"
                        style={{ background: "radial-gradient(circle, rgba(255,255,255,0.10), transparent 70%)" }}
                    />

                    <div className="relative z-10 max-w-3xl">
                        <span className="pqx-eyebrow !text-[#FF4040] mb-5 inline-flex">
                            {eyebrow}
                        </span>
                        <h2 className="pqx-h2 mt-4 text-white">
                            {title}
                        </h2>
                        <p className="mt-5 md:mt-6 text-white/70 text-base md:text-lg leading-relaxed max-w-2xl">
                            {description}
                        </p>
                        <div className="mt-8 flex flex-wrap gap-3">
                            <Link to={primary.to} data-testid="finalcta-primary" className="pqx-btn-accent">
                                {primary.label}
                                <ArrowUpRight className="w-4 h-4" />
                            </Link>
                            <Link to={secondary.to} data-testid="finalcta-secondary" className="pqx-btn-ghost-light">
                                {secondary.label}
                            </Link>
                        </div>
                    </div>

                    {/* decorative chip */}
                    <div className="hidden lg:flex absolute top-10 right-10 items-center gap-2 px-3 py-1.5 rounded-full bg-white/8 border border-white/10 text-xs text-white/70">
                        <Sparkles className="w-3.5 h-3.5 text-[#FF4040]" />
                        Enterprise-ready · 24h response
                    </div>
                </div>
            </div>
        </section>
    );
}
